$ = require 'jquery'
Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
Browser = require 'lib/browser'
CardLabelSelectView = require 'views/label/card-label-select-view'
CardMemberSelectView = require 'views/card/card-member-select-view'
CardViewHelpers = require 'views/card/card-view-helpers'
CardViewMixins = require './card-view-mixins'
Controller = require 'controller'
CustomFieldBadgesView = require 'views/custom-field/custom-field-badges-view'
DatePickerView = require 'views/card/date-picker-view'
Dates = require 'lib/dates'
require 'views/internal/data-transfer/drag-drop-events'
DragSort = require 'views/lib/drag-sort'
GuidedTourState = require 'view-models/guided-tour-state'
Keys = require 'data/keys'
LabelKeyHelper = require 'views/label/label-key-helper'
LabelState = require 'view-models/label-state'
PluginBadgesView = require 'views/plugin/plugin-badges-view'
PopOver = require 'views/lib/pop-over'
PostRender = require 'views/lib/post-render'
Promise = require 'bluebird'
QuickCardEditorView = require 'views/card/quick-card-editor-view'
Queue = require 'promise-queue'
SimplifiedStateManager = require 'lib/simplified-state-manager'
StickerView = require 'views/stickers/sticker-view'
Storage = require 'lib/storage'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
Apdex = require('debug/apdex').default
log = require 'debug/log'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'
moment = require 'moment'
l = require 'lib/localize'
warnIfFileTooLarge = require 'views/internal/warn-if-file-too-large'
pastedFileName = require 'views/internal/pasted-file-name'
stickerClip = require 'lib/util/sticker-clip'
ninvoke = require 'lib/util/ninvoke'
f = require 'effing'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'

cardTemplate = require 'views/templates/card_in_list'

HOOK_DROPPABLE_QUEUE = new Queue(1)
enqueueDroppable = (cardView) ->
  HOOK_DROPPABLE_QUEUE.add ->
    new Promise (resolve) ->
      cardView.hookDroppable()
      _.defer resolve
      return
  return

module.exports = mixin CardViewHelpers, class CardView extends View
  _.extend(@prototype, CardViewMixins)

  className: 'list-card js-member-droppable'
  tagName: 'a'

  filterDeactivated: true
  showMemberStatus: false
  applyBoardCardFilter: true
  trackApdex: true

  events:
    'moveto': 'moveTo'
    'movein': 'moveIn'

    'moveToCalendarDay': 'moveToCalendarDay'
    'moveInCalendarDay': 'moveInCalendarDay'

    'click .js-open-quick-card-editor': 'openQuickCardEditor'
    'click .js-member-on-card-menu': 'openMemberOnCardMenu'
    'click .card-label.mod-card-front': 'labelClick'
    'click': 'showDetail'

    'contextmenu': (e) ->
      # If they've got a modifier key pressed, maybe they're trying to get at the
      # system version of the context menu.  Also let developers opt out of it
      # completely with a localStorage key
      if e.ctrlKey || e.metaKey || e.shiftKey || Storage.get('nocontext')
        return

      @openQuickCardEditor(e)

    'mouseenter': -> @trigger 'mouseEnterCardView'
    'mousemove': -> @trigger 'mouseMoveCardView'
    'mouseleave': -> @trigger 'mouseLeaveCardView'

    'mouseenter .card-label.mod-card-front': 'labelMouseEnter'
    'mouseleave .card-label.mod-card-front': 'labelMouseLeave'

    'dd-enter:files': 'dragenter'
    'dd-leave:files': 'dragleave'
    'dd-drop:files': 'dropFiles'
    'dd-enter:url': 'dragenter'
    'dd-leave:url': 'dragleave'
    'dd-drop:url': 'dropUrl'

    'shortcut': 'shortcut'
    'userinput-paste:files': 'dropFiles'
    'userinput-paste:url': 'dropUrl'

  initialize: ->
    for opt in ['filterDeactivated', 'showMemberStatus', 'applyBoardCardFilter', 'trackApdex']
      if @options[opt]?
        @[opt] = @options[opt]

    PostRender.enqueue "initialize_#{ @cid }", ({ delayed }) =>
      # We haven't been listening for changes, and were deferred, so render
      # again
      if delayed
        @render()

      @makeDebouncedMethods 'render',
        'renderName',
        'renderLabels'
        'renderCover'
        'renderFiltered'
        'renderPowerUpEffects'
        'renderStickers'
        'renderBadges'
        'renderDueComplete'
        'renderCustomFieldItems'

      @listenTo @model,
        'change:name': @renderNameDebounced
        'change:labels': @renderLabelsDebounced
        'change:idAttachmentCover': @renderCoverDebounced
        'change:name change:labels change:idLabels change:due change:dueComplete': @renderFilteredDebounced
        'change:dueComplete': @renderDueComplete
        'change:dateLastActivity': =>
          @renderCoverDebounced()
          @renderPowerUpEffectsDebounced()
        'change:badges change:due change:dueComplete change:subscribed': @renderBadgesDebounced
        'keyboardMove': @scrollIntoView

      @listenTo @model.customFieldItemList, 'add remove reset change', @frameDebounce ->
        @renderCustomFieldItems()
        @renderFiltered()

      @listenTo @modelCache, "add:Notification remove:Notification change:Notification", @renderBadgesDebounced
      @listenTo Dates, 'renderInterval', @renderBadgesDebounced

      # Don't attach two listeners to the same event! Single listener, 2 function calls
      @listenTo @model.memberList, 'add remove reset', @frameDebounce ->
        @renderMembers()
        @renderFiltered()

      @listenTo @model.labelList, 'add remove reset change',
        @renderLabelsDebounced

      @listenTo @model.stickerList,
        'add remove reset change sort': @renderStickersDebounced

      board = @model.getBoard()
      @listenTo board, 'change:powerUps change:prefs.cardAging', @renderPowerUpEffectsDebounced
      @subscribe pluginsChangedSignal(board, @model), =>
        @renderCoverDebounced()
        @renderPowerUpEffectsDebounced()
      @listenTo board.filter, 'change', @renderFilteredDebounced
      @listenTo board, 'change:labels', @renderLabelsDebounced
      # Possible for a user to become deactivated
      @listenTo board, 'change:memberships', @renderMembers

      @listenTo board.customFieldList, 'add remove reset change',
        @renderCustomFieldItemsDebounced

      @listenTo board.boardPluginList, 'add remove reset change',
        @renderCustomFieldItemsDebounced

      @listenTo board.viewState, 'active-card-changed', @renderActiveState

      @listenTo board, 'permChange', @render

      # This is just here in case you're dragging a member somewhere before
      # we've managed to hook droppable. It won't work all the time; it's
      # just another cheap chance for us to get it right.
      @listenTo @, 'mouseEnterCardView', ->
        enqueueDroppable @

      @listenTo SimplifiedStateManager,
        'labels-and-edit:unlocked': @renderDebounced
        'full-view:unlocked': @renderDebounced

    return

  renderActiveState: ->
    # Don't ask me. This was here before. Should never happen, but who knows?
    if !@$el?
      return

    isActive = @model.getBoard().viewState.isCardSelected(@model)
    @$el.toggleClass 'active-card', isActive

    if isActive
      UserInput.addHandler @, { scope: 'card' }
    else
      UserInput.removeHandler @
    return

  shortcut: (key) ->
    loggedIn = Auth.isLoggedIn()
    editable = @model.editable()
    onCalendar = @onCalendar

    switch key
      when Keys.Enter
        @showDetail()
        "Enter - Open Card"

      when Keys.E
        @openQuickCardEditor()
        "E - Open Quick Card Editor"

      when Keys.T
        Controller.showCardDetail(@model, { runMethod: 'editTitle', method: 'via the T shortcut from card front' })
        "T - Open Card and Edit Title"

      when Keys.D
        if editable
          @showPopOver(DatePickerView, { trackingCategory: 'keyboard shortcut' })
          ["D - Due Dates", "On Board View"]

      when Keys.L
        if editable
          @showPopOver(
            CardLabelSelectView,
            { hideOnSelect: false }
          )
          ["L - Edit Labels", "On Board View"]

      when Keys._0, Keys._1, Keys._2, Keys._3, Keys._4, \
           Keys._5, Keys._6, Keys._7, Keys._8, Keys._9
        if editable
          fxNoUniqueLabel = (color) =>
            @showPopOver(
              CardLabelSelectView,
              { searchInit: color, hideOnSelect: true }
            )
          LabelKeyHelper.setLabelFromKey(key, @model, fxNoUniqueLabel)
          "0-9 - Toggle Specific Label"

      when Keys.A, Keys.M
        if editable
          @showPopOver(CardMemberSelectView)
          ["A - Assign Members", "Board View"]

      when Keys.Space
        board = @model.getBoard()
        # TODO: TMON-1064 Remove when experiment finishes
        if editable && (board.hasActiveMembership(Auth.me()) || board.shouldRequestJoinBoard())
          toggleMemberFn = => @model.toggleMember(Auth.myId())
          board.requestJoinBoard(toggleMemberFn)
          "Space - Toggle Assigning Self"

      when Keys.C
        if editable
          @model.close()
          "C - Archive Card"

      when Keys.AngleRight, Keys.Period
        if editable && !onCalendar
          @model.moveToNextList(if key == Keys.AngleRight then 'top' else 'bottom')
          "> - Move to Next List"

      when Keys.AngleLeft, Keys.Comma
        if editable && !onCalendar
          @model.moveToPrevList(if key == Keys.AngleLeft then 'top' else 'bottom')
          "< - Move to Previous List"

      when Keys.V
        if loggedIn
          @model.toggleVote()
          "V - Vote"

      when Keys.S
        if loggedIn
          subscribed = @model.get('subscribed')
          @model.subscribe(!subscribed)
          ["S - Subscribe", if subscribed then "Unsubscribe" else "Subscribe"]

  showPopOver: (viewClass, options = {}) ->
    PopOver.toggle
      elem: @$('.js-card-menu')
      view: viewClass
      options: _.extend({ @model, @modelCache, hideOnSelect: true }, options)

  render: ->
    log('render', "rendering card " + @model.get('name'))

    data = @model.toJSON()

    data.showCover = @showCover()
    data.showEditor =
      @model.editable() &&
      !@options.hideMenu &&
      SimplifiedStateManager.isUnlocked('labels-and-edit')

    if @model.hasStickers()
      data.hasStickers = true

    # render this stuff upfront so we don't have to thrash the layout again.
    data.labels = @labelsData()

    board = @model.getBoard()

    data.members = []
    for member in @model.memberList.models by -1
      memberData = member.toJSON()
      memberData.isVirtual = board.getOrganization()?.isVirtual(member) || board.isVirtual(member)
      memberData.isDeactivated = board.isDeactivated(member)

      data.members.push memberData

    # add classes before adding to the DOM to prevent layout thrashing.
    @$el.toggleClass('js-archive-card', @model.get('closed'))

    if @showCover() && @model.hasCover()
      @$el.addClass('is-covered')

    if @model.hasStickers()
      @$el.addClass('is-stickered')

    @el.innerHTML = cardTemplate(data)

    @renderFiltered()
    @renderBadges()
    @renderCustomFieldItems()
    @renderDueComplete()

    PostRender.enqueue "render_#{ @cid }", =>
      # make sure cards stay active when re-rendered
      @renderPluginBadges()
      @renderActiveState()
      @renderCover()
      @renderStickers()
      @renderPowerUpEffects()
      @waitForId @model, => @renderLink()

      # Hooking droppable is expensive. Use a worker queue.
      @_droppableHookedSinceRender = false
      enqueueDroppable @

    @

  # Hook a jquery.ui.droppable for dropping members from the sidebar
  # This is inordinately expensive to run, because of the width and height
  # calculations done in 'droppable', see the HOOK_DROPPABLE_QUEUE above
  hookDroppable: ->
    if Browser.isTouch()
      return
    # It's possible that we've been removed from the DOM/destroyed
    # If that's the case, then just abort
    if !@$el?
      return

    # We're using an event handler AND a queue, so only hook once per render
    if @_droppableHookedSinceRender
      return

    @_droppableHookedSinceRender = true

    if !Browser.isTouch()
      getFrame = @throttle ->
        $('.board-canvas')[0].getBoundingClientRect()
      , 100, { trailing: false }
      @$el.droppable
        refreshPositions: true
        inBounds: (e) ->
          # This is used to make sure we don't drop onto cards through the
          # sidebar. We have to recalculate this in case the user toggles
          # the sidebar with the keyboard shortcut.
          frame = getFrame()
          frame.left <= e.pageX < frame.right &&
          frame.top  <= e.pageY < frame.bottom
        accept: (el) =>
          if el.is('.js-list-draggable-board-members .member')
            return true
          if el.is('.js-draggable-sticker')
            return !@model?.isOverLimit?('stickers', 'perCard')
          return false
        hoverClass: 'active-card'
        drop: (e, ui) =>
          if ui.draggable.hasClass('member')
            dragged_mem_id = ui.draggable.data('id')
            dragged_mem = ui.draggable.clone()
            fInclude = @model.memberList.detect (member) -> member.id == dragged_mem_id

            if (!fInclude)
              @model.addMember(dragged_mem_id)
              track('Card', 'Add Member by Board Sidebar')

          else if ui.draggable.hasClass('js-draggable-sticker')
            sticker = ui.draggable.data('sticker')

            borderTopWidth = borderLeftWidth = borderRightWidth = 1

            # Figure out where the sticker area would be, if the card had a
            # sticker area
            stickerOffset = ui.helper.offset()
            targetOffset =
              top: @$el.offset().top + borderTopWidth
              left: @$el.offset().left + borderLeftWidth

            targetWidth = @$el.outerWidth() - borderLeftWidth - borderRightWidth

            offsetLeft = stickerOffset.left - targetOffset.left
            offsetTop = stickerOffset.top - targetOffset.top

            left = (offsetLeft / targetWidth) * 100
            stickerAreaHeight = @$('.js-card-stickers').height()

            if @$el.hasClass('is-stickered') || @$el.hasClass('is-covered')
              top = (offsetTop / stickerAreaHeight) * 100
            else
              # This card doesn't have anything on it yet; it's unlikely that
              # you're trying to place it at an exact vertical position, and
              # putting it right where you drop it will put part of the sticker
              # off of the card
              top = 0

            # if the user tries to put the sticker below the valid area, move
            # it as far down as possible
            if top > stickerAreaHeight
              top = stickerAreaHeight

            transformMatrix = Util.getElemTransformMatrix(ui.helper.find('.sticker-select-fixed'))
            if transformMatrix?
              rotate = Util.getMatrixDegrees(transformMatrix) % 360
            else
              rotate = 0

            @addNewStickerToList(sticker, left, top, rotate)

          return

    return


  addNewStickerToList: (sticker, left, top, rotate) ->
    image = sticker.id ? sticker.get('image')

    track("Card", "Sticker", image)

    @model.stickerList.create
      image: image
      left: stickerClip(left)
      top: stickerClip(top)
      rotate: rotate
      zIndex: @model.stickerList.nextZIndex()
      imageUrl: sticker.get('url')
      imageScaled: sticker.get('scaled')
    ,
      modelCache: @modelCache

    return

  showStickers: ->
    !@onCalendar

  renderStickers: (e) ->
    if !@showStickers()
      @$el.removeClass('is-stickered')
      return

    $stickersArea = @$('.js-stickers-area')
    $stickers = @$('.js-card-stickers')

    hasStickers = @model.hasStickers()
    editable = @model.editable()

    if hasStickers
      @$el.addClass('is-stickered')
      $stickersArea.removeClass('hide')
      stickerSubViews = @model.stickerList.map (sticker) =>
        @subview StickerView, sticker, {
          canRemove: editable && sticker.id && !@options.quickEditHidden
          fixedHeight: =>
            @$('.js-card-details').get(0).getBoundingClientRect().top -
            $stickersArea.get(0).getBoundingClientRect().top
          # Width of a card, without overlapping the edit control
          fixedWidth: =>
            @$('.js-card-menu').get(0).getBoundingClientRect().left -
            $stickersArea.get(0).getBoundingClientRect().left
        }, sticker.id || sticker.cid
      @ensureSubviews(stickerSubViews, $stickers)

    else
      @$el.removeClass('is-stickered')
      $stickersArea.addClass('hide')

    @

  renderName: ->
    data = @model.toJSON()

    html = templates.fill(
      'card_title_on_card_front',
      data
    )

    @$('.js-card-name').html html

    @

  renderLink: ->
    url = Controller.getCardUrl(@model)

    @$el.attr('href', url)

    @

  renderCustomFieldItems: ->
    subview = @subview CustomFieldBadgesView, @model
    @appendSubview subview, @$('.js-custom-field-badges')
    @

  renderPluginBadges: ->
    $pluginBadges = @$('.js-plugin-badges')
    @ensureSubviews [@subview(PluginBadgesView, @model)], $pluginBadges
    @

  showCover: ->
    @model.getBoard().getPref('cardCovers') && @model.hasCover() && !@onCalendar

  renderFiltered: (e) ->
    return if @options.dontFilter?

    @_visible ?= true
    board = @model.getBoard()
    # You can see the card if you aren't looking at it's board, or it matches
    # the filter of the board you're looking at
    visible = !board? ||
      !Controller.onBoardView(board.id) ||
      !@applyBoardCardFilter ||
      board.filter.satisfiesFilter(@model)
    if @_visible != visible
      # We set the height in order to help out dragsort.
      # http://stackoverflow.com/questions/9440664
      @$el.toggleClass('hide', !visible).height(if visible then "" else 0)
      @_visible = visible
    @

  renderDueComplete: ->
    @$el.toggleClass('is-due-complete', @model.get('dueComplete'))

  renderPowerUpEffects: ->
    board = @model.getBoard()

    @$el.removeClass @model.getAllAgingClasses()

    if board.isPowerUpEnabled('cardAging') && !@model.get('closed')
      data = @model.getAgingData()
      @$el.addClass data.agingClassesToAdd

  openQuickCardEditor: (e) ->
    if @options.quickEditHidden || !@model.editable()
      return

    Util.stop(e)
    PopOver.hide()
    QuickCardEditorView.open(@)
    track("Card Front", "Open Quick Card Editor")

    @

  labelClick: (e) ->
    if e && (e.ctrlKey || e.metaKey || e.shiftKey)
      return
    wasShowingLabelText = LabelState.getShowText()
    track(
      "Toggle Labels Text on Card Front",
      if wasShowingLabelText then "Hide" else "Show",
      @model.getBoard()?.id,
      "click-label"
    )
    e.preventDefault()
    e.stopPropagation()

    LabelState.toggleText()

  labelMouseEnter: (e) ->
    @$el.addClass('card-labels-hover')

  labelMouseLeave: (e) ->
    @$el.removeClass('card-labels-hover')

  moveToCalendarDay: (e, ui, calendarDayView) ->
    calendarDayView.getCardView(@model).delegateEvents()
    targetDate = new Date(calendarDayView.data.day)
    @model.changeDueDateMaintainTime(targetDate)
    calendarDayView.updateHeader()
    calendarDayView.renderCardsAndListHeaders()

  moveInCalendarDay: (e, ui, calendarDayView) ->
    calendarDayView.getCardView(@model).delegateEvents()
    calendarDayView.renderCardsAndListHeaders()

  moveTo: (e, ui, listViewDest, sameList) ->
    if ui.item.parents('.js-list').length == 0
      # Sometimes Internet Explorer 10 fires this event when the card is not
      # displayed. Just treat it as a failed drag for now. - Brett, July 2013
      # I can't reproduce this, but I'm afraid to take it out. - Ian, Oct 2014
      listViewDest?.renderCards()
      return

    cards = ui.item.parents('.js-list').find('.list-card:not(.placeholder,.js-composer)')
    index = cards.index(ui.item)

    if !sameList
      # We don't need the element that they dragged to stick around; we'll add
      # a new one when we modify the list
      ui.item.remove()

    @model.moveToList(listViewDest.model, index)

    return

  moveIn: (e, ui, listView) ->
    # moveTo always gets called because it's triggered from
    # sortStop even if it's outside the original list.
    if (listView.model.id == @model.get('idList'))
      @moveTo(e, ui, listView, true)

    return

  showDetail: (e) ->
    if e && (e.ctrlKey || e.metaKey || e.shiftKey)
      return

    # We don't want to open the card detail if we're in the middle of
    # dragging a card around; the "click" is probably the member dropping
    # the card
    if !@doClicks()
      return

    # Stop the event so we don't end up running the click handler for the URL
    # as well
    Util.stop(e)

    if @options.trackEvent
      @options.trackEvent()

    if @trackApdex
      Apdex.start(
        task: 'cardFromBoard',
        taskId: @model.id,
      )

    Controller.showCardDetail(@model, {
      runMethod: if @model.shouldSuggestDescription() then 'expandDesc'
      clearToolTip: GuidedTourState.hasCreatedCard(),
      method: 'from card front' ,
    })

    if @trackApdex
      Apdex.stop(
        task: 'cardFromBoard',
        taskId: @model.id,
      )

  dragenter: (e) ->
    if !@model.editable()
      return

    _height = @$el.outerHeight()

    limited = !@model.canAttach()
    restricted = !@model.canDropAttachment(e.type)
    className = if restricted
      '.list-card-dropzone-restricted'
    else if limited
      '.list-card-dropzone-limited'
    else
      '.list-card-dropzone'
    @$(className).css
      height: "#{_height}px"
      'line-height': "#{_height}px"

    @$el
    .addClass('is-drophover')
    .toggleClass('is-restricted', restricted)
    .toggleClass('is-limited', limited)

  dragleave: (e) ->
    @$el.removeClass('is-drophover')

  dropFiles: (e) ->
    if !@model.canAttach() || @model.attachmentTypeRestricted('computer')
      # Stop the event so we don't create a new card with the files
      Util.stop(e)
      return

    files = e.detail

    if warnIfFileTooLarge(@model.getBoard(), files)
      return

    Promise.resolve(files)
    .each (file) =>
      name = file.name || pastedFileName()
      ninvoke @model, 'upload', file, name
    .catch ->
      Alerts.show("unable to upload file", 'error', 'upload', 5000)
    .done()

    e.stopPropagation()

  dropUrl: (e) ->
    if !@model.canAttach() || @model.attachmentTypeRestricted('link')
      # Stop the event so we don't create a new card with the files
      Util.stop(e)
      return

    url = e.detail

    board = @model.getBoard()
    if board.attachmentUrlRestricted(url)
      return

    @model.uploadUrl url

    e.stopPropagation()

  doClicks: -> !DragSort.sorting

  scrollIntoView: ->
    # Usually just .scrollIntoView() would do
    # but IE10 scrolls the whole thing to the left
    board = @$el.closest('#board')
    list = @$el.closest('.js-list')
    listRect = list[0].getBoundingClientRect()
    scrollDelta = listRect.left + listRect.width - window.innerWidth

    @$el.closest('.js-list-cards').scrollTop(@$el.position().top)

    if listRect.left < 0
      board.animate({ scrollLeft: list.position().left }, 150)
    else if scrollDelta > 0
      board.animate({ scrollLeft: board.scrollLeft() + scrollDelta }, 150)



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-view.coffee